import React, { Component, Fragment } from 'react';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './gatewayRow.styles';

class GatewayTableHeader extends Component {
  render() {
    return (
      <Fragment>
        <p className={css(styles.heading)}>
          {I18n.t('gatewayTableHeader.title')}
        </p>
        <div className={css(styles.bases)}>
          <div className={css(styles.fieldsHeader, styles.status)}>
            Status
          </div>
          <div className={css(styles.fieldsHeader, styles.nodeAddressHeader)}>
            {I18n.t('gatewayTableHeader.nodeAddress')}
          </div>
          <div className={css(styles.fieldsHeader, styles.nodeAddressHeader)}>
            {I18n.t('gatewayTableHeader.nodeName')}
          </div>
          <div className={css(styles.fieldsHeader, styles.downtime)}>
            {I18n.t('gatewayTableHeader.downtime')}
          </div>
          <div className={css(styles.fieldsHeader, styles.trash)} />
        </div>
      </Fragment>
    );
  }
}

export default GatewayTableHeader;



// WEBPACK FOOTER //
// ./src/components/data/status/gateway/gatewayTableHeader.js